import Vue from 'vue';
import productTagTransformer from './../../transformers/productTag';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(productTagTransformer.fetch(errors));
};

export default productTag => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('product_tags', productTag)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productTag/store.js